export type AuthContext = 'ADMIN' | 'PROJECT_ADMIN' | 'HERITAGE' | 'PUBLIC';

export type SessionState = 
    | 'LOADING' 
    | 'AUTHENTICATED' 
    | 'UNAUTHENTICATED' 
    | 'EXPIRED' 
    | 'REFRESH_FAILED';

export function resolveAuthContext(pathname: string): AuthContext {
    const segments = pathname.split('/').filter(Boolean);
    
    // /admin/* -> Global Admin
    if (segments[0] === 'admin') return 'ADMIN';
    
    // /sector/project/admin/* -> Project Admin
    if (segments.includes('admin') && segments.length >= 3) return 'PROJECT_ADMIN';
    
    // /sector/project/* (no admin) -> Heritage (public)
    const systemPaths = ['admin', 'login', 'activate', 'verify', 'reset-password', '404', 'project'];
    if (segments.length >= 2 && !systemPaths.includes(segments[0])) return 'HERITAGE';
    
    // Everything else -> Public
    return 'PUBLIC';
}

export function resolveRedirectAction(context: AuthContext): 
    'REDIRECT_ADMIN_LOGIN' | 'REDIRECT_PROJECT_LOGIN' | 'IGNORE' {
    switch (context) {
        case 'ADMIN': return 'REDIRECT_ADMIN_LOGIN';
        case 'PROJECT_ADMIN': return 'REDIRECT_PROJECT_LOGIN';
        case 'HERITAGE': return 'IGNORE';
        case 'PUBLIC': return 'IGNORE';
    }
}

export function shouldHandle401(pathname: string): boolean {
    const context = resolveAuthContext(pathname);
    return context === 'ADMIN' || context === 'PROJECT_ADMIN';
}
